import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=a00a8c4a&scoped=true"
import script from "./Home1.vue?vue&type=script&lang=js"
export * from "./Home1.vue?vue&type=script&lang=js"
import style0 from "./Home1.vue?vue&type=style&index=0&id=a00a8c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a8c4a",
  null
  
)

export default component.exports